import { getTimeSinceUTCDate } from "../common/timestamp";
import template from 'lodash/template'
import { liveBind, Emitter, observe } from 'evite'
import uuid from 'uuid';
import { NewsItemView } from '../common/news'
import urls from 'urls';

let NOTIFICATION_CENTER_PER_USER_LIMIT = 1000;
let NOTIFICATION_CENTER_NAVBAR_LIMIT = 10;

const sponsoredNotificationItemTemplate = template(`
    <div class="notification-item sponsored">
        <div class="sponsored-upper"><i class="icon icon-bolt"></i>Ad</div>
        <div class="sponsored-right">
            <a href="<%- view_details_url %>"><img src="<%- re_user_image_url %>"/></a>
        </div>
        <div class="sponsored-lower">
            <a class="notification-text ui-link" href="<%- view_details_url %>"><p><%= text %></p></a>
        </div>
    </div>`);

const notificationItemTemplate = template(`
    <div class="notify-left"><%= avatar %></div>
    <div class="bullet-with-tooltip"><%- read_bullet %><span class="tooltiptext">Mark as <%- switch_read_state %></span></div>
    <div class="notification-context-menu">
        <div class="context-menu-icon"></div>
        <div class="context-menu-items-wrapper">
            <div class="context-menu-item">
                <a class="hide-notification ui-link" role="button" href="javascript:void 0;">Hide this notification</a>
            </div>
            <div class="context-menu-item">
                <%= event_settings_link %>
            </div>
        </div>
    </div>
    <div class="notify-center">
        <p>
            <a class="notification-text ui-link" href="<%- view_details_url %>"><%= text %></a>
        </p>
        <div class="time-label"><%- timestamp %></div>
    </div>
    `);

const notificationCenterTemplate = template(`
    <div class="flex-container">
        <div id="news_item_wrapper_<%- news_item_type %>" class="news-item-wrapper <%- news_item_type %>" data-template-name="news_item_<%- news_item_type %>"></div>
        <div class="notifications-list-header">
            <span class="notifications-list-title">Your Evite Notifications</span>
            <a href="javascript:void 0;" class="notifications-mark-all-as-read">Mark all as read</a>
        </div>
        <ul class="notifications-list"></ul>
         <div class="notifications-list-footer">
            <a href="/all-notifications" class="ui-link">View all notifications</a>
        </div>
    </div>
`);

let emptyListTemplate = template(`
    <div class="empty-notification-items-message">
        <p>This is the very beginning of your Evite Notifications. Check here to stay up to date on all of your Evite events!</p>
        <p>Host or RSVP to an event, and let the notifications roll in.</p>
    </div>`);


function ajax_notify_update(ids_to_update, prop, val, success_callback, error_callback=null) {
    // TODO - Ask Rudy if this needs to be sent when ids_to_update is empty.
    let url = urls.get('ajax_notify_update');
    let payload = {"messages": ids_to_update};
    payload[prop] = val;
    window.evite.fetch(url, {
        method: "post",
        body: JSON.stringify(payload),
        credentials: 'include',
        cache: "no-cache",
        headers: {
            "X-CSRFToken": evite.cookie("csrftoken"),
            "Accept": "application/json",
            "Content-Type": "application/json",
        }
    }).then((response) => {
        return response.clone().json()
    }).then(json => {
        success_callback(json);
    }).catch((error) => {
        evite.error("Error while posting to " + url + " errorThrown=" + error);
        if (error_callback) {
            error_callback();
        }
    })
}

class NotificationModel extends Emitter {
    id = null;
    re_user_image_url = null;
    p_text = null;
    msg_type = null;
    created = null;
    event_id = null;
    text = null;
    view_details_url = null;
    re_user_avatar_disk = null;
    read = false;
    p_context = null;
    re_user_initials = null;
    event_settings_url = null;
    post_id = null;
    re_user_id = null;
    viewed = false;
    collection = null;

    constructor (obj) {
        super();
        this.id = uuid.v1();
        Object.assign(this, obj);
        this.addEventListener('change', this.notify_collection_of_changes)
    }

    destroy () {
        let id_to_delete = this['created'];
        ajax_notify_update(id_to_delete, "delete", true, () => {
            const event = new CustomEvent('model:destroy', {'detail': this.id});
            this.collection.dispatchEvent(event);
        });
    }

    notify_collection_of_changes() {
        this.dispatchEvent(new CustomEvent('collection:change'));
    }

    get created_as_date () {
        const CREATED_REGEX = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.(\d{3})/;
        let match = CREATED_REGEX.exec(this.created);
        let d = new XDate();
        if (match) {
            d.setUTCFullYear(match[1], parseInt(match[2], 10) - 1, match[3]);
            d.setUTCHours(match[4], match[5], match[6], match[7]);
        }
        return d;
    }
}


class NotificationsCollection extends Emitter {
    models = [];

    constructor (options) {
        // none of this applies if the user is not logged in, let's save ourselves some browser time
        super();
        if (options.fetchCallback) this.fetchCallback = options.fetchCallback;
        this.addEventListener('model:destroy', this.removeNotification, false);
        // this.addEventListener('model:change', this.dispatchEvent(new CustomEvent('collection:change')), false);
        this.fetchNotifications();
    }

    markAllAs (attr) {
        let models_to_update = this.models.filter(model => model[attr] === false).map(model => model['created']);
        ajax_notify_update(models_to_update, attr, true, () => {
            this.models = this.models.map(model => {
                model[attr] = true;
                return model
            });
            this.dispatchEvent(new CustomEvent('collection:change'));
        });
    }

    get length(){
      return this.models.length;
    }

    get unviewed () {
        return this.models.filter(model => model['viewed'] === false).length
    }

    get unread () {
        return this.models.filter(model => model['read'] === false).length
    }

    removeNotification = (e) => {
      this.models = this.models.filter( model => model.id !== e.detail);
      this.dispatchEvent(new CustomEvent('collection:removeModel'))
    };

    fetchNotifications = () => {
            window.evite.fetch(urls.get('ajax_notify_items'), {
                method: 'get',
                credentials: "same-origin"
            })
            .then(response => {
                return response.clone().json();
            })
            .then((data) => {
                data = data || {};
                data.notifications = data.notifications || [];

                this.models.splice(0);
                data.notifications.forEach((model) => {
                    const new_model = new NotificationModel({ ...model, collection: this});
                    const observed_model = observe(new_model, (prop, val) => {
                        observed_model.dispatchEvent(new CustomEvent('change'))
                    });
                    this.models.push(observed_model)
                });
                this.dispatchEvent(new CustomEvent('collection:fetch'));
                this.fetchCallback && this.fetchCallback(this);
                this.dispatchEvent(new CustomEvent('collection:news_item_fetch', {detail: data.news_item}));
          })
    };
}

class NotificationsBadgeView {
    constructor (options) {
        this.collection = options.collection;
        this.el = options.el;
        this.collection.addEventListener('collection:fetch', this.render, false);
        // may not need this one :
        this.collection.addEventListener('collection:change', this.render, false);
        this.collection.addEventListener('collection:removeModel', this.render, false);
        this.render()
    }

    render = () => {
       if(this.collection.unviewed > 0){
          this.el.innerHTML = this.collection.unviewed;
          this.el.parentNode.classList.add("badged");
        }
        else {
          this.el.innerHTML = '';
          this.el.parentNode.classList.remove("badged");
        }
        return this;
    }
}

class NotificationView {

    constructor (options) {
        this.el = options.el;
        this.options = options;
        this.model = options.model;
        this.parent_view = options.parent_view;
        this.context_controls_should_be_visible = false;
        this.template = notificationItemTemplate;
        this.render();
        return this.el
    }

    bind_events = () => {
        this.model.addEventListener('change', this.render);
        this.el.querySelector('.hide-notification').addEventListener('click', this.hideNotification);
        this.el.querySelector('.bullet-with-tooltip').addEventListener('click', this.toggleRead);
        this.el.querySelector('.notification-context-menu').addEventListener('click', this.selectContextMenu);
        this.el.addEventListener('mouseenter', this.showContextControls);
        this.el.addEventListener('mouseleave', this.hideContextControls);
    };

     _avatar = () => {
        let avatar_element = this.model.re_user_initials;
        let re_user_image_url = this.model.re_user_image_url;
        let re_user_avatar_disk = this.model.re_user_avatar_disk;
        if (this.model.re_user_image_url) {
            avatar_element = `<img class="profile-image" src="${ this.model.re_user_image_url}"/>`;
        }
        return `<div class="photo"><div class="avatar avatar-${re_user_avatar_disk} small">${avatar_element}</div></div>`;
    };

    _event_settings_link = () => {
        if (!this.model.event_settings_url) {
            return "";
        }
        return `<a class="ui-link" href="${this.model.event_settings_url}">Adjust Notification settings for this event</a>`;
    };

    _rendercontext = () => {
        let timestamp = getTimeSinceUTCDate(this.model.created_as_date);
        let read_bullet = "●";
        let switch_read_state = "read";
        if (this.model.read) {
            read_bullet = "○";
            switch_read_state = "unread";
        }
        const extra = {
            "avatar": this._avatar(),
            "event_settings_link": this._event_settings_link(),
            "read_bullet": read_bullet,
            "switch_read_state": switch_read_state,
            "timestamp": timestamp
        };
        return Object.assign({}, this.model, extra);
    };

    render = () => {
        let context = this._rendercontext();
        let html = this.template(context);
        this.el.innerHTML = html;
        if (this.model.read) this.el.classList.add('was-read');
        if (!this.model.read && this.el.classList.contains('was-read')) this.el.classList.remove('was-read')
        if (this.context_controls_should_be_visible) this.showContextControls();
        this.bind_events();
    };

    toggleRead = () => {
        let read_new = !(this.model.read);
        ajax_notify_update([this.model.created], 'read', read_new, () => {
            this.model.read = read_new;
        })
    };

    hideNotification = (event) => {
        event.preventDefault();
        this.model.destroy();
    };

    selectContextMenu = (event) => {
        if(this.contextMenuItemsWrapper) { this.contextMenuItemsWrapper.style.display = 'block'; }
        if(this.notificationContextMenu) { this.notificationContextMenu.focus(); }
    };

    hideContextMenu = () => {
        if(this.contextMenuItemsWrapper) { this.contextMenuItemsWrapper.style.display = 'none'; }
    };

    showContextControls = () => {
        if(this.bulletWithTooltip){
            this.bulletWithTooltip.style.visibility = 'visible';
        }
        if(this.notificationContextMenu){
            this.notificationContextMenu.style.visibility = 'visible';
        }

        this.context_controls_should_be_visible = true;
    };

    hideContextControls = () => {
        this.hideContextMenu();

        if(this.bulletWithTooltip){
            this.bulletWithTooltip.style.visibility = 'hidden';
        }
        if(this.notificationContextMenu){
            this.notificationContextMenu.style.visibility = 'hidden';
        }

        this.context_controls_should_be_visible = false;
    };

    // TODO - Get from constructor options
    get contextMenuItemsWrapper() {
        return this.el.querySelector('.context-menu-items-wrapper');
    }

    get notificationContextMenu() {
        return this.el.querySelector('.notification-context-menu');
    }

    get bulletWithTooltip() {
        return this.el.querySelector('.bullet-with-tooltip');
    }
}

class SponsoredNotificationView {

    initialize(options) {
        this.options = options;
        this.el = options.el;
        this.id = options.id;
        this.model = options.model;
        this.parent_view = this.options.parent_view;
        this.el.addEventListener(`model:change-${ this.id }`, this.render);
    }

    get template() {
        let template_text = this.parent_view.sponsored_notification_template;
        return template(template_text);
    }

    render () {
        const html = this.template(this.model.attributes);
        this.el.innerHTML = html;
        return this.el
    }

}
class NotificationCenterView {
    constructor(options) {
        this.options = options;
        this.el = options.el;
        this.collection = options.collection;
        this.news_item_view = new NewsItemView();

        // Cache this element from the template for use later
        this.template = notificationCenterTemplate;
        this.empty_notification_items_list = emptyListTemplate;
        this.page_size = NOTIFICATION_CENTER_NAVBAR_LIMIT;
        if (this.options.nav_support !== true) {
            this.page_size = NOTIFICATION_CENTER_PER_USER_LIMIT;
        }
        this.page_index = 0;

        if (this.options.pulldown) {
            this.options.pulldown.addPulldownClickCallback(this.markAllAsViewed);
        }
        this.bind_events();

        if(this.collection.length) {
          this.render();

          if(this.options.viewing_all_notifications) {
            this.markAllAsViewed();
          }
        }
    }

    bind_events = () => {
        this.collection.addEventListener('collection:news_item_fetch', this.newsItemFetched, false);
        this.collection.addEventListener('collection:change', this.render, false);
        this.collection.addEventListener('collection:fetch', this.render, false);
        this.collection.addEventListener('collection:removeModel', this.render, false);


        liveBind(this.el, 'click', '.notifications-mark-all-as-read', this.markAllAsRead);

        if (this.options.pulldown) {
            liveBind(this.el, 'scroll', '.notifications-list', this.showShadows);
        }
    };

    showShadows = (e) => {
        if(this.notificationsListHeader) {
            if (e.currentTarget.scrollTop > 0) {
                this.notificationsListHeader.classList.add('has-shadow')
            } else {
                this.notificationsListHeader.classList.remove('has-shadow')
            }
        }

        if(this.notificationsListFooter) {
          if (e.currentTarget.scrollHeight > e.currentTarget.clientHeight) {
              this.notificationsListFooter.classList.add('has-shadow')
          } else {
              this.notificationsListFooter.classList.remove('has-shadow')
          }

          if (e.currentTarget.scrollTop >= (e.currentTarget.scrollHeight - e.currentTarget.clientHeight - 4)) {
              this.notificationsListFooter.classList.remove('has-shadow')
          }
        }
    };

    render = () => {
        if(this.notificationsContainer) {
          const context = { news_item_type: getNewsItemTypeFrom(this.notificationsContainer) };
          this.notificationsContainer.innerHTML = this.template(context);
        }

        if(this.notificationsList) {
          this.notificationsList.innerHTML = '';
          let has_sponsored = false;

          // Create a view for each Notification.
          this.collection.models.forEach(model => {
              let view = null;
              let el = document.createElement('li');
              el.classList.add('notification-item');
              let view_options = {
                  el: el,
                  model: model,
                  parent_view: this
              };
              if (model["msg_type"] === "sponsored") {
                  view = new SponsoredNotificationView(view_options);
                  has_sponsored = true;
              } else {
                  view = new NotificationView(view_options);
              }
              this.notificationsList.appendChild(view)
          });

          if (this.collection.models.length < 1) {
              // console.log(this.empty_notification_items_list())
              let item = this.empty_notification_items_list();
              this.notificationsList.innerHTML = item;
          }
        }
        if (this.notificationsListFooter && this.collection.models.length > 6) {
            this.notificationsListFooter.classList.add('has-shadow')
        }

        this.news_item_view.instantiateIn(this.notificationsContainer);

        return this;
    };

    markAllAsViewed = () => {
        if (this.collection.unviewed > 0) {
            this.collection.markAllAs("viewed");
        }
    };

    markAllAsRead = () => {
        this.collection.markAllAs("read");
    };

    newsItemFetched = (e) => {
      this.news_item_view.setNewsItem(e.detail);
    };

    // TODO - Get from constructor options
    get notificationsContainer() {
        return this.el.querySelector('.notifications-container');
    }

    get notificationsList() {
        return this.el.querySelector('.notifications-list');
    }

    get notificationsListHeader() {
        return this.el.querySelector('.notifications-list-header');
    }

    get notificationsListFooter() {
        return this.el.querySelector('.notifications-list-footer');
    }
}


function getNewsItemTypeFrom(notificationsContainer) {
  const classes = notificationsContainer.classList;
  for (let idx=0; idx < classes.length; idx++) {
    if (classes[idx].startsWith('news-item_')) {
      return classes[idx].replace('news-item_', '');
    }
  }
  return '';
}


export {
    NotificationModel,
    NotificationsCollection,
    NotificationView,
    NotificationsBadgeView,
    NotificationCenterView,
    SponsoredNotificationView,
};



// WEBPACK FOOTER //
// ./assets/es6/notifications/notify.es6